module.exports = __webpack_public_path__ + "static/023.thumb-9fa703e0396f39136986508f93423747.jpg";